var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,3.2C16.1,3.2,3.2,16.1,3.2,32S16.1,60.8,32,60.8S60.8,47.9,60.8,32S47.9,3.2,32,3.2z M42,31.8 c-2.4,8-10.8,12.5-18.7,10c-8-2.3-12.4-10.8-10-18.6c2.3-8,10.8-12.4,18.6-10C39.8,15.5,44.4,23.9,42,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,19.1c-3.3-1-6.2,0.1-7.1,2.8c-0.4,1.5,0,2.9,1.2,4.3v0.1c-2,0.2-3.6,1.2-4.2,3.2 c-0.6,2.2,0.5,5.1,4.7,6.4c3.8,1.1,6.9-0.1,7.7-3.1c0.6-2.1-0.4-3.9-1.7-4.9v-0.1c1.8-0.4,2.9-1.5,3.4-2.8 C35.1,22.9,34.1,20.2,30.3,19.1z M28.8,31.9c-0.4,1.1-1.5,1.7-2.8,1.3c-1.5-0.4-2-1.8-1.6-2.9c0.4-1.2,1.3-1.8,2.7-1.8 C28.4,29.3,29.2,30.5,28.8,31.9z M30.8,24.3c-0.4,1-1.3,1.6-2.3,1.6c-1.2-0.7-2-1.8-1.6-2.9c0.4-1,1.2-1.7,2.6-1.2 C30.8,22.1,31,23.3,30.8,24.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeno);
export default __webpack_public_path__ + "static/media/keno.3425385f88821517bd1722f35fb323cb.svg";
export { ForwardRef as ReactComponent };